"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classNameGenerator = require("../theming/classNameGenerator");
var _constants = require("./constants");
var _classnames = _interopRequireDefault(require("../Spinner/classnames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = (0, _classNameGenerator.generateComponentClassNames)({
  component: _constants.COMPONENT_NAME,
  children: ['Component'],
  supportSelectors: [_classnames["default"]]
});